"use client";
import * as React from "react";
import {
  Content as RadixDialogContent,
  type ContentProps as RadixDialogContentProps,
  Description as RadixDialogDescription,
  type DescriptionProps as RadixDialogDescriptionProps,
} from "@radix-ui/themes/components/dialog";
import { useElement } from "../widgets-context.js";
import { getDomProps, namespaceClassNames } from "../utils.js";
import { useDialogOverlayHack } from "./utils.js";

interface ContentProps extends RadixDialogContentProps {}

const DialogContent = React.forwardRef<HTMLDivElement, ContentProps>(
  function DialogContent({ className, ...props }, forwardedRef) {
    const element = useElement("dialog");
    const { ref } = useDialogOverlayHack(forwardedRef, {
      className: namespaceClassNames("dialog-overlay"),
      selector: ".rt-DialogOverlay",
    });
    return (
      <RadixDialogContent
        ref={ref}
        {...getDomProps({ elementId: "dialog", className })}
        {...props}
        {...element}
      />
    );
  },
);

interface DescriptionProps extends RadixDialogDescriptionProps {}

const DialogDescription = React.forwardRef<
  HTMLParagraphElement,
  DescriptionProps
>(function DialogDescription({ size = "2", ...props }, forwardedRef) {
  return <RadixDialogDescription ref={forwardedRef} size={size} {...props} />;
});

export { DialogContent as Content, DialogDescription as Description };
export type { ContentProps, DescriptionProps };

export {
  Close,
  Root,
  Title,
  Trigger,
} from "@radix-ui/themes/components/dialog";
export type {
  CloseProps,
  RootProps,
  TitleProps,
  TriggerProps,
} from "@radix-ui/themes/components/dialog";
